<template>
  <div class="shop-dark-wrapper px-4 px-sm-6 px-md-10 text-center">
    <!-- Header Logo -->
    <v-col cols="12" class="d-flex justify-center pt-8 mb-4">
      <v-img height="50px" max-width="150px" @click="$router.push('/')" contain src="/img/roodyLogoGreen.png" style="cursor: pointer"></v-img>
    </v-col>

    <!-- Celebratory Checkmark -->
    <div class="success-checkmark my-6 animate-fade-in-up stagger-1">
      <div class="check-icon">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
      </div>
    </div>

    <!-- Title Section -->
    <div class="animate-fade-in-up stagger-2 mb-8">
      <h1 class="premium-title-gradient text-h4 font-weight-black mb-2">Vielen Dank für deinen Einkauf!</h1>
      <p class="grey--text text--lighten-1 mx-auto" style="max-width: 600px; font-size: 1.05rem; line-height: 1.5">
        Du kannst deine gekauften Produkte / Gutscheine nun direkt herunterladen. Deine Einkäufe findest du im Anschluss auch immer in deinem Profil
        unter "Einkäufe".
      </p>
    </div>

    <!-- Product Voucher Grid -->
    <v-row class="justify-center animate-fade-in-up stagger-3 px-2">
      <v-col cols="12" sm="6" md="4" v-for="(product, index) of data[0].products" :key="'produkt-' + index" class="d-flex">
        <v-card
          dark
          flat
          class="glass-card fill-height d-flex flex-column"
          style="overflow: hidden; width: 100%; border: 1px dashed rgba(255, 255, 255, 0.15) !important">
          <div class="image-zoom-container pa-3">
            <v-img aspect-ratio="1.6" class="rounded-xl" :src="'/img/' + product.picture"></v-img>
          </div>

          <v-card-title class="justify-center white--text font-weight-bold pt-3 pb-1 text-h6">
            {{ product.title }}
          </v-card-title>

          <v-card-text class="flex-grow-1 px-4 py-2">
            <div class="text-subtitle-1 white--text font-weight-bold mb-2">
              für {{ product.personalization.prename }} {{ product.personalization.lastname }}
            </div>

            <!-- Styled quote box for voucher text -->
            <div
              class="pa-3 rounded-lg text-left mb-3"
              style="background: rgba(255, 255, 255, 0.02); border-left: 3px solid #00b074; font-size: 0.9rem; line-height: 1.4; min-height: 60px">
              <span class="grey--text text--lighten-2">"{{ product.personalization.text }}"</span>
            </div>
          </v-card-text>

          <v-divider class="mx-4" style="background-color: rgba(255, 255, 255, 0.08)"></v-divider>

          <v-card-text class="py-4 d-flex justify-space-between align-center px-6">
            <span class="grey--text text-caption">Gutscheinwert</span>
            <span style="color: #00b074; font-weight: 800; font-size: 1.25rem">CHF {{ product.price }}.-</span>
          </v-card-text>

          <!-- Download button inside ticket -->
          <div class="pa-4 pt-0">
            <v-btn @click="downloadFile(index)" class="premium-btn py-5" block>
              <v-icon left>mdi-download</v-icon>
              Ausdruck herunterladen
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Bottom navigation button -->
    <v-col cols="12" class="text-center mt-12 mb-10 animate-fade-in-up stagger-4">
      <v-btn class="premium-btn-outline px-10 py-6" x-large @click="$router.push('/user')">
        <v-icon left>mdi-account-circle-outline</v-icon>
        Zum Profil wechseln
      </v-btn>
    </v-col>
  </div>
</template>

<script>
import api from "../../api"
import { mapGetters, mapActions, mapState } from "vuex"

export default {
  data() {
    return {
      data: { products: [] },
    }
  },
  async created() {
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.data = await api.getPaymentInfos(this.$route.params.id)
      console.log(this.data, "da isch de purchase")
    } else {
      this.$toast.error("Dein Einkauf wurde nicht gefunden oder konnte nicht deinem Account zugewiesen werden")
      this.$router.push("/")
    }
  },
  methods: {
    async downloadFile(index) {
      this.$toast.success("Dein Ausdruck wird generiert")
      await api.downloadRealVoucher({ _id: this.data[0]._id, product: index })
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

.shop-dark-wrapper {
  --bg-primary: #0b0c10;
  --bg-secondary: #1f2833;
  --bg-dark-accent: #0b0c10;
  --bg-card: rgba(255, 255, 255, 0.02);
  --bg-card-hover: rgba(255, 255, 255, 0.04);
  
  --brand-primary: #00B074;
  --brand-primary-glow: rgba(0, 176, 116, 0.35);
  --brand-gradient: linear-gradient(135deg, #00B074 0%, #008758 100%);
  --brand-gradient-hover: linear-gradient(135deg, #05d08b 0%, #00B074 100%);
  
  --border-color: rgba(255, 255, 255, 0.05);
  --border-color-hover: rgba(0, 176, 116, 0.3);
  --border-color-focus: rgba(0, 176, 116, 0.5);
  
  --text-primary: #ffffff;
  --text-secondary: #94a3b8;
  --text-muted: #64748b;
  
  --font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  
  --shadow-premium: 0 25px 50px -12px rgba(0, 0, 0, 0.7);
  --shadow-glow: 0 0 40px rgba(0, 176, 116, 0.12);
  --shadow-glow-hover: 0 0 50px rgba(0, 176, 116, 0.25);
  --blur-amount: 20px;

  background: radial-gradient(circle at 0% 0%, #102019 0%, #08090c 70%) !important;
  color: var(--text-primary) !important;
  min-height: 100vh;
  font-family: var(--font-family) !important;
  letter-spacing: -0.01em;
}

.premium-title-gradient {
  background: linear-gradient(135deg, #ffffff 40%, #a3e635 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: var(--font-family);
  font-weight: 800 !important;
  letter-spacing: -0.03em;
  text-transform: none !important;
}

::v-deep .glass-card {
  background: var(--bg-card) !important;
  backdrop-filter: blur(var(--blur-amount)) !important;
  -webkit-backdrop-filter: blur(var(--blur-amount)) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 28px !important;
  box-shadow: var(--shadow-premium) !important;
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

::v-deep .glass-card:hover {
  background: var(--bg-card-hover) !important;
  border-color: var(--border-color-hover) !important;
  box-shadow: var(--shadow-premium), var(--shadow-glow-hover) !important;
  transform: translateY(-6px) scale(1.01) !important;
}

.image-zoom-container {
  overflow: hidden;
  border-radius: 20px;
  position: relative;
  background: #0f172a;
}

::v-deep .image-zoom-container .v-image {
  transition: transform 0.8s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

::v-deep .glass-card:hover .image-zoom-container .v-image {
  transform: scale(1.05) rotate(0.5deg) !important;
}

::v-deep .premium-btn {
  background: var(--brand-gradient) !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 0.95rem !important;
  letter-spacing: 0.02em !important;
  border-radius: 20px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 176, 116, 0.4), var(--shadow-glow) !important;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
  border: none !important;
  text-transform: none !important;
}

::v-deep .premium-btn:hover {
  background: var(--brand-gradient-hover) !important;
  transform: translateY(-3px) scale(1.02) !important;
  box-shadow: 0 15px 30px -5px rgba(0, 176, 116, 0.55), 0 0 30px rgba(0, 176, 116, 0.3) !important;
}

::v-deep .premium-btn:active {
  transform: translateY(-1px) !important;
}

::v-deep .premium-btn-outline {
  background: transparent !important;
  color: var(--brand-primary) !important;
  font-weight: 700 !important;
  border: 1.5px solid rgba(0, 176, 116, 0.4) !important;
  border-radius: 20px !important;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
  text-transform: none !important;
  box-shadow: none !important;
}

::v-deep .premium-btn-outline:hover {
  background: rgba(0, 176, 116, 0.06) !important;
  border-color: var(--brand-primary) !important;
  color: var(--brand-primary) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 0 20px rgba(0, 176, 116, 0.1) !important;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  opacity: 0;
  animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.stagger-1 { animation-delay: 0.1s; }
.stagger-2 { animation-delay: 0.2s; }
.stagger-3 { animation-delay: 0.3s; }
.stagger-4 { animation-delay: 0.4s; }

::v-deep .v-btn::before {
  background-color: transparent !important;
}
</style>
